import type { Common } from "./ios";

import { EMPTY } from "~/shared/str";

function mapDtoToEntity({
  name,
  description,
  category: { name: categoryName, description: categoryDescription, ...category },
  features,
  ...rest
}: Common.OutSchema) {
  return {
    ...rest,
    name: name ?? EMPTY,
    description: description ?? EMPTY,
    category: {
      ...category,
      name: categoryName ?? EMPTY,
      description: categoryDescription ?? EMPTY,
    },
    features: features.map(({ name, description, ...rest }) => ({
      ...rest,
      name: name ?? EMPTY,
      description: description ?? EMPTY,
    })),
  };
}

export { mapDtoToEntity };
